import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {propTypes} from 'react-props-decorators';
import {LabeledCheckbox} from "components/ui/checkbox";
import _ from 'lodash';
import FormGroup from "components/ui/form-group";
import TextFieldMask from "components/ui/text-field-mask";
import TextField from "components/ui/text-field";
import formats from "dictionaries/formats";
import moment from "moment";
import * as alerts from "helpers/alerts";
import Select from 'components/ui/select';
import Input from "components/ui/form/input";
import Radio from "components/ui/form/radio";
import Datepicker from "components/ui/form/datepicker";
import classNames from 'classnames';
import Textarea from "components/ui/form/textarea";
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

export default class BaseEditorFormComponent extends Component {

    state = {};

    async componentDidMount() {
        await this.setState(this.props.data);
    }

    getState() {
        return this.state;
    }

    getData() {
        return this.state;
    }

    /**
     * @param {String} field
     * @return {String}
     */
    getValue(field) {
        return _.get(this.getState(), field);
    }

    /**
     * @param {String} field
     * @param {*} value
     */
    async setValue(field, value) {
        let state = this.getState();

        _.set(state, field, value);

        this.setState(state);
    }

    submit() {
        this.props.onSubmit(this.getState());
    }

    onDeleteClick() {
        alerts.prompt('Удалить?', '', () => {
            this.props.onDelete(this.getValue('uuid'));
        });
    }

    renderCheckbox(fieldName, label, props = {}) {
        return (
            <LabeledCheckbox
                checked={this.getValue(fieldName)}
                label={label}
                onChange={(value => this.onChangeInput(fieldName, {target: {value}}))}
                {...props} />
        );
    }

    renderDatepicker(fieldName, label, props = {}) {
        let value = this.getValue(fieldName);
        value = value && moment(value).format(formats.DATE);
        if (value === 'Invalid date') {
            value = null;
        }

        return this.renderInputMask(fieldName, label, '99.99.9999', value ? {value} : {});
    }


    renderInputMask(fieldName, label, mask, props = {}) {
        return (
            <FormGroup name={fieldName} label={label}>
                <TextFieldMask mask={mask} {...this.inputProps(fieldName)} {...props}/>
            </FormGroup>
        );
    }

    maskInput(fieldName, mask, props = {}) {
        return (
            <TextFieldMask mask={mask} {...this.inputProps(fieldName)} {...props}/>
        );
    }

    renderNumberField(fieldName, label, props = {}) {
        props['type'] = 'number';

        return (
            <FormGroup name={fieldName} label={label}>
                <TextField {...this.textFieldProps(fieldName)} {...props}/>
            </FormGroup>
        );
    }

    renderTextField(fieldName, label, props = {}) {
        return (
            <FormGroup name={fieldName} label={label}>
                <TextField {...this.textFieldProps(fieldName)} {...props}/>
            </FormGroup>
        );
    }

    textInput(fieldName, props = {}) {
        return (
            <Input {...this.textFieldProps(fieldName)} {...props}/>
        );
    }

    textarea(fieldName, props = {}) {
        return (
            <Textarea {...this.textFieldProps(fieldName)} {...props}/>
        );
    }

    wysiwyg(fieldName, props = {}) {
        props.onChange = (value) => {
            this.onChangeInput(fieldName, {target: {value}});
        };
        props.formats = [
            'header',
            'bold', 'italic', 'underline', 'strike', 'blockquote',
            'list', 'bullet', 'indent',
            'link', 'image', 'align',
        ];
        props.modules = {
            toolbar: [
                [{'header': [1, 2, false]}],
                ['bold', 'italic', 'underline', 'strike', 'blockquote'],
                [{'list': 'ordered'}, {'list': 'bullet'}, {'indent': '-1'}, {'indent': '+1'}],
                [{'align': []}],
                ['link'],
                ['clean'],
            ],
        };

        const error = this.getError(fieldName);
        if (error) {
            props.className = 'wrong';
        }

        const styleClassName = classNames(error ? 'input__style_state_wrong' : '');

        let textFieldProps = this.textFieldProps(fieldName);
        textFieldProps.value = textFieldProps.value || '';

        return (
            <div>
                <ReactQuill {...textFieldProps} {...props}/>
                <div className={styleClassName}>
                    {error ?
                        <span className="input__style_state_msg_wrong">{error}</span> : null}
                </div>
            </div>
        );
    }

    select(fieldName, options = [], props = {}) {
        props.value = this.getValue(fieldName);
        props.name = fieldName;
        props.options = props.sort ? _.sortBy(options, 'label') : options;
        if (!props.onChange) {
            props.onChange = (e) => {
                let value = e ? e.value : null;

                if (props.multi) {
                    value = e;
                    value = _.map(value, 'value');
                }

                this.onChangeInput(fieldName, {target: {value}});
            };
        }

        const error = this.getError(fieldName);
        if (error) {
            props.className = 'wrong';
        }

        const styleClassName = classNames(error ? 'input__style_state_wrong' : '');

        return (
            <div>
                <Select {...props}/>
                <div className={styleClassName}>
                    {error ?
                        <span className="input__style_state_msg_wrong">{error}</span> : null}
                </div>
            </div>
        );
    }

    selectAsync(fieldName, loadOptions, props = {}) {
        props.value = this.getValue(fieldName);
        props.name = fieldName;
        props.loadOptions = loadOptions;
        if (!props.onChange) {
            props.onChange = (e) => {
                let value = e ? e.value : null;
                let label = e ? e.label : null;

                if (props.multi) {
                    value = e;
                    value = _.map(value, 'value');
                }

                this.onChangeInput(fieldName, {target: {value, label}});
            };
        }

        const error = this.getError(fieldName);
        if (error) {
            props.className = 'wrong';
        }

        const styleClassName = classNames(error ? 'input__style_state_wrong' : '');

        return (
            <div>
                <Select.Async {...props}/>
                <div className={styleClassName}>
                    {error ?
                        <span className="input__style_state_msg_wrong">{error}</span> : null}
                </div>
            </div>
        );
    }

    radio(fieldName, radioValue, label, props = {}) {
        const value = this.getValue(fieldName);

        return (
            <Radio
                checked={value === radioValue}
                field={fieldName}
                value={radioValue}
                label={label}
                onChange={this.newListener(fieldName)}
                {...props}
            />
        );
    }

    datepicker(fieldName, props = {}) {
        return (
            <Datepicker
                {...props}
                value={this.getValue(fieldName)}
                onChange={this.newListener(fieldName)}
                error={this.getError(fieldName)}
            />
        )
    }

    renderSelectField(fieldName, label, options = [], props = {}) {
        props['value'] = this.getValue(fieldName);
        props['name'] = fieldName;
        props['options'] = options;
        props['onChange'] = (e) => {
            const value = e ? e.value : null;
            this.onChangeInput(fieldName, {target: {value}});
        };

        return (
            <FormGroup name={fieldName} label={label}>
                <Select {...props}/>
            </FormGroup>
        );
    }

    textFieldProps(fieldName) {
        return {
            size: 'md',
            ...this.inputProps(fieldName)
        };
    }

    inputProps(fieldName) {
        return {
            value: this.getValue(fieldName) || '',
            onChange: this.newListener(fieldName),
            name: fieldName,
            error: this.getError(fieldName),
        };
    }

    getError(fieldName) {
        const field = _.findLast(fieldName.split('.'));

        return _.get(this.state.errors, field) || _.get(this.state.errors, fieldName);
    }

    newListener(fieldName) {
        return this.onChangeInput.bind(this, fieldName);
    }

    onChangeInput(field, {target: {value}}) {
        this.setValue(field, value);
    }

    async loadDictionaries(dictionaries, component = null, withoutOrder = false) {
        let meta = {
            filters: {
                withComponent: component,
            },
        };
        if (!withoutOrder) {
            meta.order = {
                column: 'name',
                direction: 'asc',
            };
        }
        const response = await this.props.getDictionaryList(dictionaries, meta);
        if (response.isOk) {
            let state = this.state;
            _.each(response.payload.items, (item) => {
                state[item.key] = _.map(item.documents, (document) => ({
                    value: document.uuid,
                    label: document.short_name || document.name,
                    document,
                }));
            });
            this.setState(state);
        } else {
            response.showErrors();
        }
    }

    async getDictionary(dictionary, component = null, withoutOrder = false) {
        let meta = {
            filters: {
                withComponent: component,
            },
        };
        if (!withoutOrder) {
            meta.order = {
                column: 'name',
                direction: 'asc',
            };
        }
        const response = await this.props.getDictionaryList(dictionary, meta);
        if (response.isOk) {
            return _.map(response.payload.documents, (document) => ({
                value: document.uuid,
                label: document.short_name || document.name,
                document,
            }));
        } else {
            response.showErrors();
        }
    }
}


// WEBPACK FOOTER //
// ./src/components/modules/base/base-editor-form.js